import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { actionGetPlaces, actionDeletePlace } from "../actions/PlaceActions"
import { LOGIN_ROUTE, PLACES_ADD_ROUTE, PLACES_EDIT_ROUTE } from "../config/RoutesConstants"
import { 
  Container, 
  IconButton,
  Button,
  Box, 
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Paper,
  Typography, 
  Fab,
  Toolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableFooter,
  TablePagination,
  Tooltip,
  Input,
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import SearchIcon from '@material-ui/icons/Search';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Util, { ERROR } from '../common/Util'


class Places extends React.PureComponent{
  constructor(props){
    super(props)
    this.state={page:0, rowPerPage:5, count:0, places:[], filter:"", placeForDelete:false}
    this.renderTableHeader=this.renderTableHeader.bind(this)
    this.renderTableBody=this.renderTableBody.bind(this)
    this.onChangePage=this.onChangePage.bind(this)
    this.onChangeRowsPerPage=this.onChangeRowsPerPage.bind(this)
    this.getDeletePlaceSuccess=this.getDeletePlaceSuccess.bind(this)
    this.onConfirmDeletePlace=this.onConfirmDeletePlace.bind(this)
    this.onAddPlace=this.onAddPlace.bind(this)
    this.onSearch=this.onSearch.bind(this)
  }

  componentWillMount(){
    if (this.props.login) {
      // console.log("COMPONENT WILL MOUNT")
      this.props.actionGetPlaces(this.onChangePage, this.getPlacesError)
    }
  }

  getPlacesError(e){
    console.log("ERROR PLACES", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al listar las ubicaciones.")
  }

  onChangePage(evt=null, newPage=0){
    let from=newPage*this.state.rowPerPage
    let end=from+this.state.rowPerPage
    let filter = new RegExp(this.state.filter,"ig")
    let places = this.props.placeList.filter((e)=>{return e.plcName.match(filter)})
    let count = places.length
    places = places.slice(from, end)
    this.setState({page:newPage, count:count, places:places})
  }

  onChangeRowsPerPage(evt){
    let from=this.state.page*evt.target.value
    let end=from+evt.target.value
    let filter = new RegExp(this.state.filter,"ig")
    let places = this.props.placeList.filter((e)=>{return e.plcName.match(filter)})
    let count = places.length
    places = places.slice(from, end)
    this.setState({rowPerPage:evt.target.value, count:count, places:places})
  }

  onSearch(evt){
   this.setState({filter:evt.target.value},this.onChangePage)
  }

  onAddPlace(){
    this.props.history.push(PLACES_ADD_ROUTE)
  }

  onEditPlace(place){
    this.props.history.push(PLACES_EDIT_ROUTE, place)
  }

  onConfirmDeletePlace(){
    this.props.actionDeletePlace(this.state.placeForDelete,this.getDeletePlaceSuccess,this.getDeletePlaceError)
    this.setState({placeForDelete:false})
  }
  
  onDeletePlace(place){
    this.setState({placeForDelete:place})  
  }

  getDeletePlaceSuccess(){
    this.props.actionGetPlaces(()=>{this.onChangePage(null,this.state.page)}, this.getPlacesError)
  }

  getDeletePlaceError(e){
    console.log("ERROR", e)
    if(!(e&&e.status&&e.status==401))
      Util.showNoty(ERROR, "Ocurrió un error al elminar la ubicación.")
  }

  renderTableHeader(){
    const {theme} = this.props
    const headers = ["Nombre","Dirección"]
    return (
    <TableRow>
      {headers.map((label)=>{
        return (
          <TableCell>{label}</TableCell>
        )
      })}
      <TableCell style={theme.table.actionsColumn}>Acciones</TableCell>
    </TableRow>
    )
  }

  renderTableBody(){
    const {theme} = this.props
    let places = this.state.places
    // console.log("PLACES LIST", places, this.props.placeList)
    if(!places||places.length==0){
      return <Box style={theme.table.empty}>No se encontraron registros</Box>
    }
    return places.map((item, index)=>{
      return (
        <TableRow style={index%2==0?theme.table.row:theme.table.rowColor}>
          <TableCell>{item.plcName}</TableCell>
          <TableCell>{item.plcAddress}</TableCell>
          <TableCell style={theme.table.actionsColumn}>
            <Tooltip title="Editar ubicación">
              <IconButton onClick={this.onEditPlace.bind(this,item)}>
                <EditIcon/>
              </IconButton>
            </Tooltip>
            <Tooltip title="Eliminar ubicación">
              <IconButton onClick={this.onDeletePlace.bind(this, item)}>
                <DeleteIcon/>
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      )
    })
  }

  render(){
    const { theme, placeList } = this.props
    return (
      <Box style={theme.mainContainer}>
        <Box style={theme.title.container}>
          <Typography variant="h1">Ubicaciones</Typography>
          <Typography variant="subtitle1">Crea ubicaciones</Typography>
        </Box>
        <Container style={theme.table.container}>        
          <Paper>
            <Typography style={theme.paper.title} variant="h2">Listado de ubicaciones</Typography>
            <Toolbar style={theme.table.toolbar}>
              <Tooltip title="Crear nueva ubicación">
                <Fab color="primary" onClick={this.onAddPlace} size="small">
                  <AddIcon />
                </Fab>
              </Tooltip>
              <Box>
                <Input placeholder="Buscar" onChange={this.onSearch}/>
              </Box>
            </Toolbar>
              <Table stickyHeader>
                <TableHead > 
                  {this.renderTableHeader()}
                </TableHead>
                <TableBody>
                  {this.renderTableBody()}
                </TableBody>
              </Table> 
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={this.state.count}
              rowsPerPage={this.state.rowPerPage}
              page={this.state.page}
              onChangePage={this.onChangePage}
              onChangeRowsPerPage={this.onChangeRowsPerPage}
            />
          </Paper>
          <Dialog open={this.state.placeForDelete}>
            <DialogTitle>Eliminar ubicación</DialogTitle>
            <DialogContent>
              <DialogContentText>¿Está seguro que desea eliminar la ubicación?</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="contained" color="secondary" onClick={()=>{this.setState({placeForDelete:null})}}>Cancelar</Button>
              <Button variant="contained" color="primary" onClick={this.onConfirmDeletePlace}>Eliminar</Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    )
  }
}

function mapStateToProps(store) {
  // console.log("STORE", store)
  return {
    login: store.auth.login,
    placeList: store.plc.placeList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetPlaces,
      actionDeletePlace
    },
    dispatch
  );
}

export default  withRouter(
                  withTheme(
                    connect(
                      mapStateToProps,
                      mapDispatchToProps
                    )(Places)
                  )
                )


// WEBPACK FOOTER //
// ./src/screens/Places.js